import { render, staticRenderFns } from "./PrivacyPolicyComponent.vue?vue&type=template&id=71b0bfba&scoped=true&"
import script from "./PrivacyPolicyComponent.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyComponent.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyComponent.vue?vue&type=style&index=0&id=71b0bfba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0bfba",
  null
  
)

export default component.exports